export default {
  apiVersion: '2023-03-01',
  dataset: import.meta.env.PUBLIC_SANITY_DATASET,
  projectId: 'v8xj0upx',
  useCdn: true,
};
